import { Box, Button, Stack, Text } from '@ltvco/refresh-lib/theme';

import { SummaryComponentProps } from './DataTypes/SummaryTypes';
import {
  PropertyReportRenderer,
  PhoneReportRenderer,
  EmailReportRenderer,
  VehicleReportRenderer,
} from './ReportRenderers';

const renderReportByType = (reportType: string, reportData: any) => {
  switch (reportType.toLowerCase()) {
    case 'property':
      return <PropertyReportRenderer data={reportData} />;
    case 'phone':
      return <PhoneReportRenderer data={reportData} />;
    case 'email':
      return <EmailReportRenderer data={reportData} />;
    case 'vehicle':
      return <VehicleReportRenderer data={reportData} />;
    case 'person':
      // TODO: Implement PersonReportRenderer
      return null;
    case 'obituary':
      // TODO: Implement ObituaryReportRenderer
      return null;
    case 'username':
      // TODO: Implement UsernameReportRenderer
      return null;
    default:
      return null;
  }
};

export const SummaryComponent = ({
  reportData,
  currentPermalink,
  handleButtonClick,
  reportsAssociated,
}: SummaryComponentProps) => {
  return (
    <Stack spacing={2}>
      {Object.entries(reportData).map(([reportType, reports]) => {
        if (!reports || reports.length === 0) {
          return null;
        }
        return (
          <Stack key={reportType} spacing={2} margin={'24px 0 !important'}>
            {reports.map((report, index) => (
              <Stack key={index}>
                {renderReportByType(reportType, report)}
                <Box
                  sx={{
                    backgroundColor: 'rats.light',
                    padding: 1,
                    borderRadius: '8px',
                    display: 'flex',
                    flexDirection: { xs: 'column', md: 'row' },
                    justifyContent: { xs: 'center', md: 'space-between' },
                    alignItems: 'center',
                    margin: '12px 0',
                    gap: { xs: 1, md: 0 },
                  }}
                >
                  <Text
                    sx={{
                      fontWeight: 700,
                      maxWidth: { xs: '100%', md: 'auto' },
                      textAlign: { xs: 'center', md: 'left' },
                    }}
                  >
                    View the full report on the right{' '}
                    <span style={{ fontWeight: 400 }}>for more details.</span>
                  </Text>
                  {reports && reportsAssociated && (
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: { xs: 'center', md: 'flex-end' },
                      }}
                    >
                      <Button
                        variant="outlined"
                        size="small"
                        onClick={() => handleButtonClick(reportsAssociated[0])}
                        disabled={
                          currentPermalink === reportsAssociated[0].permalink
                        }
                      >
                        View full report
                      </Button>
                    </Box>
                  )}
                </Box>
                <Text sx={{ fontWeight: 700 }}>
                  Want to dig deeper?{' '}
                  <span style={{ fontWeight: 400 }}>
                    {reportType === 'phone'
                      ? 'Look up the owner or email to start a new search.'
                      : 'Try a quick search on the owner.'}
                  </span>
                </Text>
              </Stack>
            ))}
          </Stack>
        );
      })}
    </Stack>
  );
};
